import React from 'react';
import { Button } from 'react-bootstrap';
import { BrowseMetaChip, BrowseTypePill } from '../browse/BrowseContactLink';
import { memberDisplayName, formatMemberAge, formatMemberSexeShort } from '../browse/browseFormatters';

const TYPE_TONE = {
  AGENT: 'agent',
  CONJOINT: 'partner',
  CONJOINTE: 'partner',
  ENFANT: 'child'
};

export default function MemberListRows({ rows, memberTypeLabels = {}, onViewDetail }) {
  return rows.map((m) => {
    const fullName = memberDisplayName(m);
    const typeLabel = memberTypeLabels[m.type] || m.type || '—';
    const tone = TYPE_TONE[m.type] || 'neutral';
    const sexLabel = formatMemberSexeShort(m.sexe);
    const ageLabel = formatMemberAge(m.date_naissance);

    return (
      <article
        key={m.id}
        className="recv-browse-row recv-browse-row--member"
        role="listitem"
      >
        <div className="recv-browse-list__cell recv-browse-list__cell--lead">
          <div className="recv-browse-row__identity">
            <div className="recv-browse-row__title" title={fullName}>
              {fullName}
            </div>
            <div className="recv-browse-row__meta-line">
              <span className="font-monospace">{m.matricule || 'Sans matricule'}</span>
              <BrowseTypePill tone={tone}>{typeLabel}</BrowseTypePill>
            </div>
          </div>
        </div>
        <div className="recv-browse-list__cell recv-browse-list__cell--profile">
          <span className="recv-browse-row__label">Profil</span>
          <div className="recv-browse-member-profile" title={`Sexe ${sexLabel} · Âge ${ageLabel}`}>
            <span className="recv-browse-member-profile__sexe">{sexLabel}</span>
            <span className="recv-browse-member-profile__sep" aria-hidden>
              ·
            </span>
            <span className="recv-browse-member-profile__age">{ageLabel}</span>
          </div>
        </div>
        <div className="recv-browse-list__cell recv-browse-list__cell--company">
          <span className="recv-browse-row__label">Société</span>
          <BrowseMetaChip kind="building">{m.company_name || '—'}</BrowseMetaChip>
        </div>
        <div className="recv-browse-list__cell recv-browse-list__cell--action">
          <span className="recv-browse-row__label">Action</span>
          <Button
            size="sm"
            variant="outline-secondary"
            className="recv-browse-action-btn"
            onClick={() => onViewDetail?.(m)}
          >
            Détail
          </Button>
        </div>
      </article>
    );
  });
}
